import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SyncCourierStopStatusMutationVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
  status: Types.Scalars['String']['input'];
}>;


export type SyncCourierStopStatusMutation = { __typename?: 'mutation_root', update_mobility_stops?: { __typename?: 'mobility_stops_mutation_response', affected_rows: number } | null };

export type SyncCourierOrdersInTransitMutationVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
}>;


export type SyncCourierOrdersInTransitMutation = { __typename?: 'mutation_root', update_delivery_orders?: { __typename?: 'delivery_orders_mutation_response', affected_rows: number } | null };

export type SyncCourierOrdersDeliveredMutationVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
  deliveredAt: Types.Scalars['timestamptz']['input'];
}>;


export type SyncCourierOrdersDeliveredMutation = { __typename?: 'mutation_root', update_delivery_orders?: { __typename?: 'delivery_orders_mutation_response', affected_rows: number } | null };


export const SyncCourierStopStatusDocument = gql`
    mutation syncCourierStopStatus($runId: bigint!, $status: String!) {
  update_mobility_stops(where: {run_id: {_eq: $runId}}, _set: {status: $status}) {
    affected_rows
  }
}
    `;
export type SyncCourierStopStatusMutationFn = Apollo.MutationFunction<SyncCourierStopStatusMutation, SyncCourierStopStatusMutationVariables>;

/**
 * __useSyncCourierStopStatusMutation__
 *
 * To run a mutation, you first call `useSyncCourierStopStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCourierStopStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCourierStopStatusMutation, { data, loading, error }] = useSyncCourierStopStatusMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSyncCourierStopStatusMutation(baseOptions?: Apollo.MutationHookOptions<SyncCourierStopStatusMutation, SyncCourierStopStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCourierStopStatusMutation, SyncCourierStopStatusMutationVariables>(SyncCourierStopStatusDocument, options);
      }
export type SyncCourierStopStatusMutationHookResult = ReturnType<typeof useSyncCourierStopStatusMutation>;
export type SyncCourierStopStatusMutationResult = Apollo.MutationResult<SyncCourierStopStatusMutation>;
export type SyncCourierStopStatusMutationOptions = Apollo.BaseMutationOptions<SyncCourierStopStatusMutation, SyncCourierStopStatusMutationVariables>;
export const SyncCourierOrdersInTransitDocument = gql`
    mutation syncCourierOrdersInTransit($runId: bigint!) {
  update_delivery_orders(
    where: {run_id: {_eq: $runId}}
    _set: {status: "in_transit"}
  ) {
    affected_rows
  }
}
    `;
export type SyncCourierOrdersInTransitMutationFn = Apollo.MutationFunction<SyncCourierOrdersInTransitMutation, SyncCourierOrdersInTransitMutationVariables>;

/**
 * __useSyncCourierOrdersInTransitMutation__
 *
 * To run a mutation, you first call `useSyncCourierOrdersInTransitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCourierOrdersInTransitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCourierOrdersInTransitMutation, { data, loading, error }] = useSyncCourierOrdersInTransitMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useSyncCourierOrdersInTransitMutation(baseOptions?: Apollo.MutationHookOptions<SyncCourierOrdersInTransitMutation, SyncCourierOrdersInTransitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCourierOrdersInTransitMutation, SyncCourierOrdersInTransitMutationVariables>(SyncCourierOrdersInTransitDocument, options);
      }
export type SyncCourierOrdersInTransitMutationHookResult = ReturnType<typeof useSyncCourierOrdersInTransitMutation>;
export type SyncCourierOrdersInTransitMutationResult = Apollo.MutationResult<SyncCourierOrdersInTransitMutation>;
export type SyncCourierOrdersInTransitMutationOptions = Apollo.BaseMutationOptions<SyncCourierOrdersInTransitMutation, SyncCourierOrdersInTransitMutationVariables>;
export const SyncCourierOrdersDeliveredDocument = gql`
    mutation syncCourierOrdersDelivered($runId: bigint!, $deliveredAt: timestamptz!) {
  update_delivery_orders(
    where: {run_id: {_eq: $runId}}
    _set: {status: "delivered", delivery_status: "delivered", delivered_at: $deliveredAt}
  ) {
    affected_rows
  }
}
    `;
export type SyncCourierOrdersDeliveredMutationFn = Apollo.MutationFunction<SyncCourierOrdersDeliveredMutation, SyncCourierOrdersDeliveredMutationVariables>;

/**
 * __useSyncCourierOrdersDeliveredMutation__
 *
 * To run a mutation, you first call `useSyncCourierOrdersDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCourierOrdersDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCourierOrdersDeliveredMutation, { data, loading, error }] = useSyncCourierOrdersDeliveredMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      deliveredAt: // value for 'deliveredAt'
 *   },
 * });
 */
export function useSyncCourierOrdersDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<SyncCourierOrdersDeliveredMutation, SyncCourierOrdersDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCourierOrdersDeliveredMutation, SyncCourierOrdersDeliveredMutationVariables>(SyncCourierOrdersDeliveredDocument, options);
      }
export type SyncCourierOrdersDeliveredMutationHookResult = ReturnType<typeof useSyncCourierOrdersDeliveredMutation>;
export type SyncCourierOrdersDeliveredMutationResult = Apollo.MutationResult<SyncCourierOrdersDeliveredMutation>;
export type SyncCourierOrdersDeliveredMutationOptions = Apollo.BaseMutationOptions<SyncCourierOrdersDeliveredMutation, SyncCourierOrdersDeliveredMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/syncCourierStopStatus.mutation.gql}
 */
export async function syncCourierOrdersDelivered(
  variables: SyncCourierOrdersDeliveredMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<SyncCourierOrdersDeliveredMutation['update_delivery_orders']>
export async function syncCourierOrdersDelivered(
  variables: SyncCourierOrdersDeliveredMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<SyncCourierOrdersDeliveredMutation>
export async function syncCourierOrdersDelivered(
  variables: SyncCourierOrdersDeliveredMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<SyncCourierOrdersDeliveredMutation['update_delivery_orders'] | SyncCourierOrdersDeliveredMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<SyncCourierOrdersDeliveredMutation>(
    SyncCourierOrdersDeliveredDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_orders
}

/**
 * @source {@link src/features/partsDelivery/queries/syncCourierStopStatus.mutation.gql}
 */
export async function syncCourierOrdersInTransit(
  variables: SyncCourierOrdersInTransitMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<SyncCourierOrdersInTransitMutation['update_delivery_orders']>
export async function syncCourierOrdersInTransit(
  variables: SyncCourierOrdersInTransitMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<SyncCourierOrdersInTransitMutation>
export async function syncCourierOrdersInTransit(
  variables: SyncCourierOrdersInTransitMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<SyncCourierOrdersInTransitMutation['update_delivery_orders'] | SyncCourierOrdersInTransitMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<SyncCourierOrdersInTransitMutation>(
    SyncCourierOrdersInTransitDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_orders
}

/**
 * @source {@link src/features/partsDelivery/queries/syncCourierStopStatus.mutation.gql}
 */
export async function syncCourierStopStatus(
  variables: SyncCourierStopStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<SyncCourierStopStatusMutation['update_mobility_stops']>
export async function syncCourierStopStatus(
  variables: SyncCourierStopStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<SyncCourierStopStatusMutation>
export async function syncCourierStopStatus(
  variables: SyncCourierStopStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<SyncCourierStopStatusMutation['update_mobility_stops'] | SyncCourierStopStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<SyncCourierStopStatusMutation>(
    SyncCourierStopStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_mobility_stops
}